import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {RedEnvelopeFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";

export abstract class ASign extends ABusiness {
    readonly icon = () => h(RedEnvelopeFilled, {style: 'color: #a855f7'});
    readonly title = '报名';
    readonly description = '';
    readonly implementations = [{value: 'sign', label: '报名'}];

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }
}